/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-27 14:00:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-09-14 10:41:49
 */
import common from "./common";
import config from "../config/config";
import Vue from "vue";
import i18n from "@/config/i18n";
const time = (value: Date | string, type?: string) => {
  if (value) {
    if (typeof value === "number") {
      const typeStr = type || "yyyy-mm-dd hh:mm:ss";
      return common.userDate(value, typeStr);
    } else {
      return value;
    }
  } else {
    return "";
  }
};

const Fixed = (value: number | string, type?: number): string | number => {
  if (typeof value === "number" && !isNaN(value)) {
    const n = type && type >= 0 ? type : 2;
    return value.toFixed(n);
  } else {
    return 0;
  }
};

const fileUrl = (value: string) => {
  if (value) {
    return config.fileImg + value;
  } else {
    return "";
  }
};
const defaultText = (value: string | number): string | number => {
  if (value || value == 0) {
    return value;
  } else {
    return "--";
  }
};
const bankCard = (value: string | number): string => {
  if (typeof value == "number") {
    value = value + "";
  }
  return value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
};
const money = (value: number): number | string => {
  if (value > 1000) {
    return (value / 1000).toFixed(2) + i18n.t("unitText.k");
  } else if (value != null && value != undefined) {
    return value.toFixed(2);
  } else {
    return "";
  }
};
export const defaultNumber = (value: number): number => {
  if (value || value == 0) {
    return value;
  } else {
    return 0;
  }
};

export const percentage = (value: number): string | number => {
  if (value > 0) {
    return value + "%";
  } else {
    return "-";
  }
};
export const percentageValue = (
  value: number,
  num?: number
): string | number => {
  if (typeof value == "number") {
    num = 2 || num;
    value = parseFloat((value * 100).toFixed(num));
    return value + "%";
  } else {
    return "-";
  }
};
Vue.filter("time", time);
Vue.filter("toFixed", Fixed);
Vue.filter("fileUrl", fileUrl);
Vue.filter("defaultText", defaultText);
Vue.filter("bankCard", bankCard);
Vue.filter("money", money);
Vue.filter("defaultNumber", defaultNumber);
Vue.filter("percentage", percentage);
Vue.filter("percentageValue", percentageValue);
